import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FooterMain } from './FooterMain';
import NavMenu from './NavMenu';
import LayoutQRC from '../layout/layout';

export const Layout=(props)=> {

    const location = useLocation();

    const [currentroute, setcurrentroute] = useState(location.pathname);

    useEffect(() => {
        setcurrentroute(location.pathname);
    }, [location]);

    return (
        <div className="layout-main">
            {(currentroute.toUpperCase() !== "/DKD2024" && currentroute.toLowerCase() !== "/family-and-friends" &&
                currentroute.toLowerCase() !== "/customer-info" && currentroute.toLowerCase() !== "/thankyou-page" &&
                currentroute.toLowerCase() !== "/paymentstatus"
                && currentroute.toLowerCase() !== "/dishkichampionstrophy"
                && currentroute.toLowerCase() !== "/iplcontestwatcho"
                && currentroute.toLowerCase() !== "/leaderboard"
                && currentroute.toLowerCase() !== "/pastwinner"
                && currentroute.toLowerCase() !== "/watchodownload"
                && currentroute.toLowerCase() !== "/watchogrievance" && currentroute.toLowerCase() !== "/watchogrievancereport"
                && currentroute.toLowerCase() !== "/contactus"
                && currentroute.toLowerCase() !== "/faq"
            ) &&
                <NavMenu />
            }

            {(currentroute.toLowerCase() !== "/contactus"
                && currentroute.toLowerCase() !== "/faq"
            ) &&
                <>{ props.children }
                {currentroute === "/" && <> <br /> <br /><br /> <br /><FooterMain /></>}
                </>
            }

            {(currentroute.toLowerCase() === "/contactus"
                || currentroute.toLowerCase() === "/faq"
            ) &&
                <>
                    <LayoutQRC />
                {props.children}
            </>
            }
      </div>
    );
}
